// Copyright (c) 2016 Deere & Company

import PartRequest from '@deere/cps-it.warranty-model-factory/lib/part-return';
import t from 'tcomb';

const SearchResults = t.list(PartRequest, 'SearchResults');

export const getDefaultState = () => new SearchResults([]);

export default SearchResults;



// WEBPACK FOOTER //
// ./src/part-requests/search/state/search-results.js